<div class="modal-header" appCustomAutofocus>
    <div class="modal-title"><h3>Initialize Reviews</h3></div>
</div>
<div class="modal-body">
    <div style="margin-bottom: 15px;">
        <input type="checkbox" style="width:25px;height:25px;display:flex;" [(ngModel)]="formData.disableSelfReview" />
        <span style="display:flex;margin-top:-25px;margin-left:30px;">Disable Employee Self Review</span>
    </div>
    <div [ngClass]="{invalidField : formData.selectedEmpTemplate == null}">
        <label><strong>Choose Review Template for Employees:</strong></label>
        <ng-select [(ngModel)]="formData.selectedEmpTemplate"
                   placeholder="Select a template..."
                   [searchable]="true" [clearable]="false"
                   (change)="getEmpl()" required>
            <ng-option *ngFor="let data of templateList" [value]="data.ChecklistTemplateID">
                {{data.ChecklistTemplateName}}
            </ng-option>
        </ng-select>
    </div>
    <div style="margin-top:10px;" [ngClass]="{invalidField : formData.selectedManTemplate == null}">
        <label><strong>Choose Review Template for Managers:</strong></label>
        <ng-select [(ngModel)]="formData.selectedManTemplate"
                   placeholder="Select a template..."
                   [searchable]="true" [clearable]="false">
            <ng-option *ngFor="let data of templateList" [value]="data.ChecklistTemplateID">
                {{data.ChecklistTemplateName}}
            </ng-option>
        </ng-select>
    </div>
    <div *ngIf="formData.selectedEmpTemplate != null" style="margin-top:15px;">
        <div style="margin-bottom:15px;">
            <input type="checkbox" style="width:25px;height:25px;display:flex;" [(ngModel)]="formData.selectedAll" (change)="selectAll()">
            <span style="display:flex;margin-top:-25px;margin-left:30px;">Select All - {{count}} employees selected</span>
        </div>
        <label><strong>Select employees to initialize:</strong></label>
        <input type="text" [(ngModel)]="formData.searchText" class="form-control" (ngModelChange)="filterList()" placeholder="Type to search..." style="margin-bottom:15px;" />
        <div style="max-height:400px;overflow-x:hidden;">
            <ul *ngFor="let data of filterEmplList" style="list-style:none;padding-left:0px;cursor:pointer;margin-bottom:5px;border:1px solid darkgrey;border-radius:7px;" class="clickableRow">
                <li (click)="selectEmployee(data)" [ngClass]="{'activeList' : data.selected}" style="padding:4px;">PRCo {{data.PRCo}} - {{data.Employee}} - {{data.EmployeeName}}</li>
            </ul>
        </div>
    </div>
    <div *ngIf="formData.selectedEmpTemplate != null" style="margin-top:15px;">
        <label><strong>Review Due By:</strong></label>
        <div class="input-group">
            <input type="text"
                   class="form-control"
                   [(ngModel)]="formData.dueDate"
                   bsDatepicker
                   #dueDatedp="bsDatepicker"
                   [outsideClick]="true"
                   [bsConfig]="datePickerOptions"
                   style="background-color:#ffffff;" />
            <span class="input-group-append">
                <button type="button"
                        class="btn btn-outline-dark"
                        (click)="dueDatedp.show()"
                        [attr.aria-expanded]="dueDatedp.isOpen">
                    <i class="modus-icons align-bottom">calendar</i>
                </button>
            </span>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()">Cancel</button>
    <button type="button" class="btn btn-success" (click)="initializeClicked()" [disabled]="formData.dueDate == null || count < 1 || formData.selectedEmpTemplate == null || formData.selectedManTemplate == null || formData.initializing">Initialize</button>
</div>
